import { isMobile } from "@common_lib/base/utils/src/tools"

export const useLabelTerms = () => {
  const authStore = useAuthStore()
  const { updateCertification } = authStore
  const { userID } = storeToRefs(authStore)
  const websiteInfoStore = useWebsiteInfoStore()
  const { state: websiteState } = storeToRefs(websiteInfoStore)

  const websiteSettingStore = useWebsiteSettingStore()
  const { certificationLocalStorage } = storeToRefs(websiteSettingStore)

  const route = useRoute()
  const router = useRouter()

  const isLoginWithHalf = computed(
    () => websiteState.value.isTempRole && userID.value !== ""
  )

  const { logout } = useLogout({ isMobile: isMobile() })
  const handleRedirection = (resetPassword: boolean, termsVersion: number[]) => {
    if (resetPassword) {
      if (route.name === "ResetPassword") return
      router.push({ name: "ResetPassword" })

      return
    }

    if (termsVersion.length) {
      if (route.name === "Terms") return

      router.push({ name: "Terms" })
    }
  }

  watch(
    () => certificationLocalStorage.value.localStorage.value,
    (storage, oldStorage) => {
      const { termsVersion, resetPassword, eventType } = storage
      const { termsVersion: oldTermsVersion, resetPassword: oldReset } = oldStorage

      if (
        termsVersion.join(",") === oldTermsVersion.join(",") &&
        resetPassword === oldReset
      )
        return

      if (termsVersion.length === 0 && resetPassword === false) {
        if (isLoginWithHalf.value) {
          logout()
        }

        if (eventType) {
          router.push({
            name: "Highlight",
            query: { eventType }
          })
          return
        }
        router.push({
          name: "Home"
        })

        return
      }

      if (!isLoginWithHalf.value) {
        logout()

        if (eventType) {
          router.push({
            name: "Highlight",
            query: { eventType }
          })
          return
        }
        router.push({ name: "Home" })

        return
      }

      updateCertification({ resetPassword, termsVersion, eventType })
      handleRedirection(resetPassword, termsVersion)
    }
  )
}

export default useLabelTerms
